/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint, ZodTypes } from '../index';
import { z } from '../zod';

export const PostAuthenticationOidcLogin = {
  id: 'authentication.login.post',
  tag: 'Authentication',
  summary: 'OIDC login',
  description: `Log in using an organization's OIDC provider`,
  method: 'post',
  route: () => `/authentication/oidc/login`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            organizationId: ZodTypes.Id,
            email: z.string().email(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            redirect: z.strictObject({ href: z.string() }),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
